var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.68 0c.619 0 1.12.501 1.12 1.12l-.001 1.12h2.241A3.36 3.36 0 0 1 22.4 5.6v15.68a3.36 3.36 0 0 1-3.36 3.36H3.36A3.36 3.36 0 0 1 0 21.28V5.6a3.36 3.36 0 0 1 3.36-3.36H5.6V1.12c0-.577.437-1.053.998-1.113L6.72 0c.619 0 1.12.501 1.12 1.12v1.12h6.719l.001-1.12c0-.577.437-1.053.998-1.113zm4.48 11.199H2.24V21.28c0 .619.501 1.12 1.12 1.12h15.68a1.12 1.12 0 0 0 1.12-1.12V11.199zM5.6 4.48H3.36A1.12 1.12 0 0 0 2.24 5.6v3.359h17.92V5.6a1.12 1.12 0 0 0-1.12-1.12h-2.241L16.8 5.6a1.12 1.12 0 0 1-.998 1.113l-.122.007a1.12 1.12 0 0 1-1.12-1.12l-.001-1.12H7.84V5.6a1.12 1.12 0 0 1-.998 1.113l-.122.007A1.12 1.12 0 0 1 5.6 5.6V4.48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.195a0eaec99e24f3ef85a43cab5de1d6.svg";
export { ForwardRef as ReactComponent };